var _line, _line2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTradingLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 27,
    viewBox: "0 0 278 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 0.5,
    x2: 142,
    y2: 0.499988,
    stroke: "#42CDFF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 142,
    y1: 0.5,
    x2: 275,
    y2: 0.500012,
    stroke: "#BD3BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 27L5.88675 22L0.113248 22L3 27ZM2.5 -2.10457e-08L2.5 22.5L3.5 22.5L3.5 2.10457e-08L2.5 -2.10457e-08Z",
    fill: "#42CDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275 27L277.887 22L272.113 22L275 27ZM274.5 -2.10457e-08L274.5 22.5L275.5 22.5L275.5 2.10457e-08L274.5 -2.10457e-08Z",
    fill: "#BD3BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTradingLines);
export default __webpack_public_path__ + "static/media/newTradingLines.fee29819ee35306c632f46bd895bbd5b.svg";
export { ForwardRef as ReactComponent };